import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type ExpiredServerCertificateConfig = typeof ExpiredServerCertificateConfig._.Config;

export const ExpiredServerCertificateConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.ExpiredServerCertificate,
  configSchema: z.object({}),
});
